import React, { useState, useContext } from "react";
import { Card, Form, Button, Alert, Spinner, InputGroup } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js";
import { AuthContext } from "../context/AuthContext";
import logo from "../assets/ShubhPaisa.svg"; 
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { BASE_URL_API_TRANXT_UAT_API } from "../Utils/Constant";

const Login = () => {
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    setLoading(true);

    try {
      const md5Password = CryptoJS.MD5(password).toString();

      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/VerifyBumppyCns`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, password: md5Password }),
        }
      );

      const data = await response.json();

      if (
        data?.status === "0" &&
        data?.result?.length &&
        data.result[0].result === "Y"
      ) {
        login({
          userId: data.result[0].user_id,
          email,
          loggedIn: true,
        });

        setSuccess(data.result[0].message);

        setTimeout(() => {
          navigate("/admin", { replace: true });
        }, 1500);
      } else {
        setError(data?.result?.[0]?.message || "Login failed");
      }
    } catch {
      setError("Server error. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        height: "100vh",
        background: "linear-gradient(135deg, #a8edea, #fed6e3)", // light gradient
      }}
    >
      <Card
        style={{ width: "380px", borderRadius: "15px" }}
        className="p-4 shadow-sm"
      >
        <div className="text-center mb-4">
          <img
            src={logo}
            alt="Logo"
            style={{ width: "100px", marginBottom: "10px" }}
          />
          <h4 className="fw-bold" style={{ color: "#333" }}>
            Welcome Back
          </h4>
          <p className="text-muted">Login to your account</p>
        </div>

        {error && <Alert variant="danger">{error}</Alert>}
        {success && <Alert variant="success">{success}</Alert>}

        <Form onSubmit={handleLogin}>
          <Form.Group className="mb-3">
            <Form.Control
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <InputGroup>
              <Form.Control
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <Button
                variant="outline-secondary"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </Button>
            </InputGroup>
          </Form.Group>

          <Button
            type="submit"
            variant="primary"
            className="w-100 fw-semibold"
            style={{ background: "#4e73df", border: "none" }}
            disabled={loading}
          >
            {loading ? (
              <>
                <Spinner size="sm" className="me-2" />
                Logging in...
              </>
            ) : (
              "Login"
            )}
          </Button>
        </Form>
      </Card>
    </div>
  );
};

export default Login;
